import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=1b5c8b1e&scoped=true&"
import script from "./Players.vue?vue&type=script&lang=ts&"
export * from "./Players.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c8b1e",
  null
  
)

export default component.exports